// GenerateImageOption.jsx
import React from "react";
import "./GenerateImageOption.css";


const GenerateImageOption = ({ setShowUploadPop, onOpen }) => {
  const handleClick = () => {
    try {
      setShowUploadPop(false);
      onOpen?.();
    } catch (err) {
      console.error("Failed to open generate image modal:", err);
    }
  };

  return (
    <button
      type="button"
      className="upload-option-item generate-image-option"
      onClick={handleClick}
    >
      <span className="upload-option-left">
        {/* image icon */}
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <path d="M21 15l-5-5L5 21" />
        </svg>
        <span>Generate Image</span>
      </span>
      <span className="new-badge">New</span>
    </button>
  );
};

export default GenerateImageOption;